import { Component, EventEmitter, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';

import { AccountType } from 'src/app/shared/constants/account';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CoreService } from 'src/app/shared/services/core.service';
import { AccountService } from 'src/app/shared/services/account.service';

import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss', '/src/assets/css/common-v2/main-custom.scss']
})

export class SidebarComponent implements OnInit, OnDestroy {
  public currentUserAccountType = null;
  public AccountType = AccountType;

  private userChangedSubscription: Subscription = null;
  public menuItems: any[] = [];

  public menuStates: Record<string, boolean> = {
    reports: false,
    accountAdministration: false,
    adManagement: false,
    finance: false,
    dashboard: false
  };
  private sidebarOpenedWithButton = false;
  @Output() sidebarOpened = new EventEmitter<void>();
  @Output() sidebarClosed = new EventEmitter<void>();
  public isAppFocused = false;

  constructor(
    private coreService: CoreService,
    private renderer: Renderer2,
    private authService: AuthService,
    private accountService: AccountService,
  ) {
    this.syncUserProperties();
  }

  ngOnInit() {
    this.userChangedSubscription = this.authService.userUpdated$.subscribe(() => {
      this.syncUserProperties();
    });
  }

  ngOnDestroy() {
    if (this.userChangedSubscription) {
      this.userChangedSubscription.unsubscribe();
    }
  }

  async syncUserProperties() {
    this.currentUserAccountType = this.coreService.getCurrentAccountType();
    
    if (this.currentUserAccountType === AccountType.ADVERTISER) {
      const accountId = this.coreService.getCurrentAccountId();
      try {
        const account = await this.accountService
          .getAccount(accountId, AccountType.ADVERTISER)
          .toPromise();
        this.isAppFocused = (account as any)?.app_focused_enabled || false;
      } catch (error) {
        console.error('Error fetching account details:', error);
        this.isAppFocused = false;
      }
    }
  }

  removeClass() {
    this.renderer.removeClass(document.body, 'mini-sidebar');
    this.sidebarOpened.emit();
  }

  addClass() {
    this.renderer.addClass(document.body, 'mini-sidebar');
    this.resetMenuStates();
    this.sidebarClosed.emit();
  }

  removeSideBar() {
    this.renderer.removeClass(document.body, 'aside-left-open');
  }

  shouldShowItemFor(accountType: string) {
    return this.currentUserAccountType === accountType;
  }

  isMenuOpen(menuName: string): boolean {
    return this.menuStates[menuName];
  }

  isSidebarOpen() {
    return !document.body.classList.contains('mini-sidebar');
  }

  showHideSidebar() {
    if (!document.body.classList.contains('mini-sidebar')) {
      this.addClass();
    } else {
      this.removeClass();
    }

    this.resetMenuStates();
  }

  resetMenuStates() {
    this.menuStates = {
      reports: false,
      accountAdministration: false,
      adManagement: false,
      publisherManagement: false,
      myCampaigns: false,
      campaignOverview: false,
      postbacks: false,
      finance: false,
      dashboard: false
    };
  }

  toggleMenu(menuName: string): void {
    this.menuStates[menuName] = !this.menuStates[menuName];
  }

  toggleCollapsibleMenu() {
    this.showHideSidebar();
    this.sidebarOpenedWithButton = this.isSidebarOpen();
  }

  closeSidebarIfAllowed() {
    if (this.sidebarOpenedWithButton) {
      return;
    }

    this.addClass();
    this.removeSideBar();
  }

  shouldShowDashboard(): boolean {
    return this.currentUserAccountType === AccountType.ADVERTISER && this.isAppFocused;
  }

}
